export const constructionItems = [
    {
        'id': 1,
        'name': 'Окно',
        'url': null,
        'blender_name': null,
        'image': './demo/UI/window_icon.png',
        'priview': './demo/UI/window_icon.png',
        'height': '',
        'width': '',
        'depth': '',
        'rotation': null,
        'offsets': null,
        'color': {
            'image': '',
            'hex': '',
        },
    },
    {
        'id': 2,
        'name': 'Дверь',
        'url': null,
        'blender_name': null,
        'image': './demo/UI/door_icon.png',
        'priview': './demo/UI/door_icon.png',
        'height': '',
        'width': '',
        'depth': '',
        'rotation': null,
        'offsets': null,
        'color': {
            'image': '',
            'hex': '',
        },
    },
    {
        'id': 3,
        'name': 'Куб',
        'url': null,
        'blender_name': null,
        'image': './demo/UI/cube.png',
        'priview': './demo/UI/cube.png',
        'height': '',
        'width': '',
        'depth': '',
        'rotation': null,
        'offsets': null,
        'color': {
            'image': '',
            'hex': '',
        },
    },
];
